// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__-4x_u","header":"ClearentDisclaimer_header__vmFv9","inner":"ClearentDisclaimer_inner__1z6uP"};